import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const SplitExpensesSeparate: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="68px"
            height="50px"
            viewBox="0 0 68 50"
            fill="none"
            {...props}
        >
            <path
                d="M15.1729 33.1191L15.1729 20.7051C15.1729 19.5315 16.4598 18.8125 17.4592 19.4277L36.936 31.4159C38.2048 32.1969 38.2048 34.0414 36.936 34.8224L17.4592 46.8106C16.4598 47.4258 15.1729 46.7068 15.1729 45.5332L15.1729 33.1191Z"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <path
                d="M53.6318 20.4902L53.6318 32.9043C53.6318 34.0778 52.3449 34.7969 51.3455 34.1817L31.8687 22.1934C30.5998 21.4124 30.5998 19.568 31.8687 18.787L51.3455 6.79875C52.3449 6.1836 53.6318 6.90262 53.6318 8.07616L53.6318 20.4902Z"
                fill="#6DBBF3"
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
        </IconSVG>
    );
};
